import React from 'react';
import { ORDER_LIST_SUMMARY_TYPE_DESCRIPTION } from '../../../../constants/service/app/orderConstants';
import './OrderLabelInfoDescription.scss';

const OrderLabelInfoDescription = (props) => {
  const { orderSummaryType } = props;

  return (
    <div className="order-label-info-description">
      {ORDER_LIST_SUMMARY_TYPE_DESCRIPTION[orderSummaryType].PRICE_INFO && (
        <div className="order-label-info-price">
          <div className="title">집계된 금액 정보</div>
          <div>{ORDER_LIST_SUMMARY_TYPE_DESCRIPTION[orderSummaryType].PRICE_INFO}</div>
        </div>
      )}
      <div className="order-label-info-status">
        <div className="title">집계된 주문 상태 정보</div>
        <div>{ORDER_LIST_SUMMARY_TYPE_DESCRIPTION[orderSummaryType].STATUS_LIST}</div>
      </div>
    </div>
  );
};

export default OrderLabelInfoDescription;
